import React from 'react';
import numeral from 'numeral';
import ReactTooltip from "react-tooltip";
import { updateTestOrderPrice } from '../../../../../store/action/order';

export default function (props) { 
    const og = props.data;

    const testAction = props.test === 'notActive' ? null : (
        <div className="mt-2 text-center">
            <span className="badge badge-warning">WEBHOOK</span>
            <div className="mb-2 pointer">
                <ReactTooltip/>
                <a onClick={async () => {
                    const res = await updateTestOrderPrice(og.orderId);
                    if (!res.success) {
                    alert(`Failed update price`);
                    return
                    }
                    alert(`Berhasil update harga`);
                    window.location.reload();
                }}
                    className="action-item mr-2"
                    data-tip={'Update Harga'}
                    title={'Ganti harga pengiriman'}>
                    <i className="fas fa-money-bill-wave"></i>
                </a><br/>
                <small>UPDATE PRICE</small>
            </div>
        </div>
    )
  let itemPrice,codView,formView,insuranceView,shipmentFeeView,podView;
  let shipmentFee = og.price;

  if (og.orderType === 'form') {
    let slipButton;
    itemPrice = og.items.reduce((r,i) => {
      r = r + i.quantity*i.value;
      return r
    },0);
    if (og.paymentSlip === '') {
      slipButton = 'Belum Bayar'
    } else {
      slipButton = (
          <div>
            <div className="text-success"><b>Sudah Bayar</b></div>
            <button
                onClick={() => window.open(`${og.paymentSlip}`)}
                className="badge badge-info customer-cell-btn-primary"
            >
              <span className="btn-inner--icon">
                <i className="fas fa-receipt"/>
              </span>
              <span className="btn-inner--text ml-1">
                bukti
              </span>
            </button>
          </div>
      );
    }

    formView = (
        <div>
          <small>BIAYA BARANG</small><br/>
          <strong>Rp. {numeral(itemPrice).format("0,0")} <br/></strong>
          {slipButton}
          <div className="py-1"/>
          <small>BIAYA PENGIRIMAN</small><br/>
        </div>
    )
  } 
  
  if (og.receiverCODAmount) {
    shipmentFee = shipmentFee - og.receiverCODFee
    let text;
  
    if (og.receiverCODFee < 2000) {
      text = `Biaya COD Minimum`
    } else {
      const selectedCODCourier = props.user.cashOnDelivery.filter(i => i.courierCode === og.courierCompany);
      let addFee = 0;
      if (og.receiverCODType === '3_days') {
        addFee = 2;
      } else if (og.receiverCODType === '5_days') {
        addFee = 1;
      } 

      const codCourier = selectedCODCourier[0];
      let fee = codCourier ? codCourier.fee : 0;

      text = `Biaya COD (${fee+addFee}%)`
    }
    
    codView = (
        <div>                
          <small>DETAIL COD</small>
          <div className="rounded p-2 mb-1 border shadow--hover">
            <small>
              COD Item Value <div className={`badge ${og.receiverCODStatus ==='paid' ? 'badge-success' : 'badge-info'} badge-pill`}>{og.receiverCODStatus ? og.receiverCODStatus.toUpperCase() : null}</div> <br/>
              <b>Rp. {numeral(og.receiverCODAmount).format("0,0")} </b>
              <br/>
              {text}<br/>
              <b>Rp. {numeral(og.receiverCODFee).format("0,0")} <br/></b>
            </small>
          </div>
        </div>
    )
  } 

  if (og.receiverPODFee > 0) {
    shipmentFee = shipmentFee - og.receiverPODFee
    podView = (
        <div>                
          <small>Proof of Delivery</small>
          <div className="rounded p-2 mb-1 border shadow--hover">
            <small>
              Biaya POD <br/>
              <b>Rp. {numeral(og.receiverPODFee).format("0,0")} </b>
            </small>
          </div>
        </div>
    )
  } 

  if (og.courierInsuranceAmount) {
    let text = `Biaya Asuransi`;
    shipmentFee = shipmentFee - og.courierInsuranceFee;
    
    insuranceView = (
        <div>                
          <small>DETAIL ASURANSI</small>
          <div className="rounded p-2 mb-1 border shadow--hover">
            <small>
              Nilai Asuransi <br/>
              <b>Rp. {numeral(og.courierInsuranceAmount).format("0,0")} </b>
              <br/>
              {text}<br/>
              <b>Rp. {numeral(og.courierInsuranceFee).format("0,0")} <br/></b>
            </small>
          </div>
        </div>
    )
  } 

  if (og.receiverCODAmount || og.courierInsuranceAmount ) {
    shipmentFeeView = (
      <div>
        Shipment Fee <br/>
        <b>Rp. {numeral(shipmentFee).format("0,0")} </b>
      </div>
    )
  }

  if (og.orderType === "pickupAppBulk") {
    return (
      <div className="text-muted">
          Harga akan muncul ketika telah dijemput kurir
      </div>
    )
  } else {
    return (
      <div>
          {formView}
          <strong>Rp. {numeral(og.price).format("0,0")} <br/></strong>
          <p>{og.paymentMethod === 'bitepay' ? 'Bite Points' : og.paymentMethod.toUpperCase()}</p>
          {shipmentFeeView}
          {codView}
          {podView}
          {insuranceView}
          {testAction}
      </div>
    )
  }
}
